import {
  put, takeLatest, all, select, takeEvery,
} from 'redux-saga/effects';
import { notification } from 'antd';
import SellerActions, { sellerActionTypes } from '@Actions/sellerActions';
import TrackerActions from '@Actions/trackerActions';
import SellerService from '@Services/sellerServices';

/**
 * @param action
 */
function* _getStateCity(action) {
  try {
    yield put(SellerActions.getCityStateLoading(true));
    const cityState = yield SellerService.getCityState(action.pincode);
    yield put(SellerActions.setCityState(cityState.pincodeCity, cityState.pincodeState));
    yield put(SellerActions.getCityStateLoading(false));
  } catch (error) {
    yield put(SellerActions.getCityStateLoading(false));
  }
}

/**
 *
 */
function* getStateCity() {
  yield takeLatest(sellerActionTypes.GET_CITY_STATE, _getStateCity);
}

/**
 * @param action
 */
function* _createSeller(action) {
  try {
    yield put(SellerActions.createSellerLoading(true));
    const { payload } = action;
    const seller = yield SellerService.createSeller(payload);
    if (!seller.success) {
      notification.open({
        type: 'error',
        message: seller?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(TrackerActions.trackAction(sellerActionTypes.CREATE_SELLER.SUCCESS, {
        request: action?.payload,
        response: seller,
      }));
      notification.open({
        type: 'success',
        message: 'Vendor on-boarding successful.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(seller.seller);
      }
    }
    yield put(SellerActions.createSellerLoading(false));
  } catch (error) {
    yield put(SellerActions.createSellerLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(sellerActionTypes.CREATE_SELLER.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* createSeller() {
  yield takeLatest(sellerActionTypes.CREATE_SELLER.REQUEST, _createSeller);
}

/**
 * @param action
 */
function* _getSellerById(action) {
  try {
    yield put(SellerActions.getSellerByIdLoading(true));
    const selectedSeller = yield SellerService.getSellerById(action.sellerId, action.tenantId);
    yield put(SellerActions.getSellerByIdSuccess(selectedSeller?.sellers?.[0]));
    yield put(SellerActions.getSellerByIdLoading(false));
  } catch (error) {
    yield put(SellerActions.getSellerByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(sellerActionTypes.GET_SELLER_BY_ID.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getSellerById() {
  yield takeLatest(sellerActionTypes.GET_SELLER_BY_ID.REQUEST, _getSellerById);
}

/**
 * @param action
 */
function* _getSellerOffersById(action) {
  try {
    yield put(SellerActions.getSellerOffersByIdLoading(true));
    const state = yield select();
    const { user } = state.UserReducers;
    const tenantId = user?.tenant_info?.tenant_id;
    const selectedSellerOffers = yield SellerService.getSellerOffersById(action.sellerid, tenantId, action.page);
    yield put(SellerActions.getSellerOffersByIdSuccess(selectedSellerOffers));
    yield put(SellerActions.getSellerOffersByIdLoading(false));
  } catch (error) {
    yield put(SellerActions.getSellerOffersByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(sellerActionTypes.GET_SELLER_OFFERS_BY_ID.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getSellerOffersById() {
  yield takeLatest(sellerActionTypes.GET_SELLER_OFFERS_BY_ID.REQUEST, _getSellerOffersById);
}

/**
 * @param action
 */
function* _getSellers(action) {
  try {
    yield put(SellerActions.getSellersLoading(true));
    const sellers = yield SellerService.getSellers(action.keyword, action.tenantId, action.page, action?.limit, action?.sellerId, action?.isActive, action?.isSubcontractor, action?.sellerType, action?.isMarketplaceSeller, action?.selectedSellerIds, action?.excludeSellerIds, action?.advanceFilters);
    yield put(SellerActions.getSellersSuccess(sellers));
    yield put(SellerActions.getSellersLoading(false));
    if (action.callback) {
      action.callback(sellers);
    }
  } catch (error) {
    yield put(SellerActions.getSellersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(sellerActionTypes.GET_SELLERS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getSellers() {
  yield takeLatest(sellerActionTypes.GET_SELLERS.REQUEST, _getSellers);
}

// searchSellersName
function* _searchSellersName(action) {
  try {
    yield put(SellerActions.searchSellersNameLoading(true));
    const sellers = yield SellerService.getSellers(action.keyword, action.tenantId, action.page, action?.limit, action?.sellerId, action?.isActive, action?.isSubcontractor, action?.sellerType);
    yield put(SellerActions.searchSellersNameSuccess(sellers));
    yield put(SellerActions.searchSellersNameLoading(false));
    if (action.callback) {
      action.callback(sellers);
    }
  } catch (error) {
    yield put(SellerActions.searchSellersNameLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(sellerActionTypes.SEARCH_SELLERS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* searchSellersName() {
  yield takeLatest(sellerActionTypes.SEARCH_SELLERS.REQUEST, _searchSellersName);
}

/**
 * @param action
 */
function* _deleteSeller(action) {
  try {
    yield put(SellerActions.getSellersLoading(true));
    const deletedSeller = yield SellerService.deleteSeller(action.sellerId);
    if (deletedSeller.result) {
      yield put(SellerActions.getSellers(action?.currentPage));
      notification.open({
        type: 'success',
        message: 'Vendor deleted successfully',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: deletedSeller.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(SellerActions.getSellersLoading(false));
  } catch (error) {
    yield put(SellerActions.getSellersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(sellerActionTypes.DELETE_SELLER.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* deleteSeller() {
  yield takeLatest(sellerActionTypes.DELETE_SELLER.REQUEST, _deleteSeller);
}

/**
 * @param action
 */
function* _updateSeller(action) {
  try {
    yield put(SellerActions.updateSellerLoading(true));
    const { payload } = action;
    const updatedSeller = yield SellerService.updateSeller(payload);
    if (!updatedSeller.success) {
      notification.open({
        type: 'error',
        message: updatedSeller.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(TrackerActions.trackAction(sellerActionTypes.UPDATE_SELLER.SUCCESS, {
        request: action?.payload,
        response: updatedSeller,
      }));
      notification.open({
        type: 'success',
        message: 'Vendor update successful.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(SellerActions.updateSellerLoading(false));
  } catch (error) {
    yield put(SellerActions.updateSellerLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(sellerActionTypes.UPDATE_SELLER.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* updateSeller() {
  yield takeLatest(sellerActionTypes.UPDATE_SELLER.REQUEST, _updateSeller);
}
/**
 * @param action
 */
function* _updateSellerOffers(action) {
  try {
    yield put(SellerActions.updateSellerOffersLoading(true));
    const { payload } = action;
    const updatedSellerOffers = yield SellerService.updateSellerOffers(payload);
    if (!updatedSellerOffers.offers) {
      notification.open({
        type: 'error',
        message: updatedSellerOffers.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: 'Offer update successful.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(SellerActions.updateSellerOffersLoading(false));
  } catch (error) {
    yield put(SellerActions.updateSellerOffersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(sellerActionTypes.UPDATE_SELLER_OFFERS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* updateSellerOffers() {
  yield takeLatest(sellerActionTypes.UPDATE_SELLER_OFFERS.REQUEST, _updateSellerOffers);
}

/**
 * @param action
 */
function* _getOrgSellers(action) {
  try {
    yield put(SellerActions.getOrgSellersLoading(true));
    const {
      orgId, sellerId, tenantId, page, limit, sellerName, isVendorArchive,
    } = action;
    const orgSellers = yield SellerService.getOrgSellers(orgId, sellerId, tenantId, page, limit, sellerName, isVendorArchive);
    yield put(SellerActions.getOrgSellersSuccess(orgSellers));
    yield put(SellerActions.getOrgSellersLoading(false));
  } catch (error) {
    yield put(SellerActions.getOrgSellersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(sellerActionTypes.GET_ORG_SELLERS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getOrgSellers() {
  yield takeLatest(sellerActionTypes.GET_ORG_SELLERS.REQUEST, _getOrgSellers);
}

/**
 *
 * @param {*} action
 */
function* _getReports(action) {
  const {
    firstSubUrl, secondSubUrl, tenantId, tenantSellerId, fromDate, toDate, customerId,
  } = action;
  try {
    yield put(SellerActions.getReportsLoading(true));
    const reports = yield SellerService.getReports(firstSubUrl, secondSubUrl, tenantId, tenantSellerId, fromDate, toDate, customerId);
    yield put(SellerActions.getReportsSuccess(reports?.seller_ledger));
    yield put(SellerActions.getReportsLoading(false));
  } catch (error) {
    yield put(SellerActions.getReportsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(sellerActionTypes.GET_SELLER_DOWNLOAD_REPORTS.ERROR, {
      request: action,
      error,
    }));
  }
}
/**
 *
 */
function* getReports() {
  yield takeEvery(sellerActionTypes.GET_SELLER_REPORTS.REQUEST, _getReports);
}

/**
 *
 * @param {*} action
 */
function* _getDownloadReports(action) {
  const {
    firstSubUrl, secondSubUrl, tenantId, tenantSellerId, fromDate, toDate, fileReportType,
  } = action;
  try {
    yield put(SellerActions.getDownloadReportsLoading(true));
    const reportDownload = yield SellerService.getReportsDownload(firstSubUrl, secondSubUrl, tenantId, tenantSellerId, fromDate, toDate, fileReportType);
    if (!reportDownload) {
      notification.open({
        type: 'error',
        message: reportDownload.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(SellerActions.getDownloadReportsLoading(false));
      const link = document.createElement('a');
      link.target = '_blank';
      link.download = 'seller-account-statement';

      link.href = URL.createObjectURL(
        new Blob([reportDownload], { type: reportDownload.type }),
      );

      link.click();
      yield put(SellerActions.getDownloadReportsLoading(false));
    }
  } catch (error) {
    yield put(SellerActions.getDownloadReportsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(sellerActionTypes.GET_SELLER_DOWNLOAD_REPORTS.ERROR, {
      request: action,
      error,
    }));
  }
}
/**
 *
 */
function* getDownloadReports() {
  yield takeLatest(sellerActionTypes.GET_SELLER_DOWNLOAD_REPORTS.REQUEST, _getDownloadReports);
}

/**
 * @param action
 */
function* _sendAccountStatementMail(action) {
  try {
    yield put(SellerActions.sendAccountStatementMailLoading(true));
    const { payload } = action;
    const seller = yield SellerService.sendAccountStatementMail(payload);
    if (!seller.success) {
      notification.open({
        type: 'error',
        message: seller?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: 'Account statement sent to vendor over email',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(seller.seller);
      }
    }
    yield put(SellerActions.sendAccountStatementMailLoading(false));
  } catch (error) {
    yield put(SellerActions.sendAccountStatementMailLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(sellerActionTypes.SEND_ACCOUNT_STATEMENT_MAIL.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* sendAccountStatementMail() {
  yield takeLatest(sellerActionTypes.SEND_ACCOUNT_STATEMENT_MAIL.REQUEST, _sendAccountStatementMail);
}

function* _linkCustomer(action) {
  try {
    yield put(SellerActions.linkCustomerLoading(true));
    const { payload } = action;
    const linkedCustomer = yield SellerService.linkCustomer(payload);
    if (!linkedCustomer.success) {
      notification.open({
        type: 'error',
        message: linkedCustomer?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: 'Vendor linked to the customer successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(SellerActions.linkCustomerLoading(false));
  } catch (error) {
    yield put(SellerActions.linkCustomerLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(sellerActionTypes.LINK_CUSTOMER.ERROR, {
      request: action,
      error,
    }));
  }
}

function* linkCustomer() {
  yield takeLatest(sellerActionTypes.LINK_CUSTOMER.REQUEST, _linkCustomer);
}

/**
 *
 * @returns {Generator<Promise<*>|*, void, *>}
 * @private
 */
function* _getBulkUploadSellerMetadata() {
  try {
    yield put(SellerActions.getBulkUploadSellerMetadataLoading(true));
    yield put(SellerActions.bulkUploadSellersError(null));
    const bulkUploadMetaData = yield SellerService.getBulkUploadSellerMetadata();
    if (bulkUploadMetaData.success) {
      yield put(SellerActions.getBulkUploadSellerMetadataSuccess(bulkUploadMetaData));
    } else {
      notification.open({
        type: 'error',
        message: 'Something went wrong while initiating your request',
        duration: 4,
        placement: 'top',
      });
    }
    yield put(SellerActions.getBulkUploadSellerMetadataLoading(false));
  } catch (error) {
    yield put(SellerActions.getBulkUploadSellerMetadataLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}
/**
 *
 * @returns {Generator<*, void, *>}
 */
function* getBulkUploadSellerMetadata() {
  yield takeLatest(sellerActionTypes.GET_BULK_UPLOAD_SELLER_META_DATA.REQUEST, _getBulkUploadSellerMetadata);
}

function* _bulkUploadSellers(action) {
  try {
    yield put(SellerActions.bulkUploadSellersLoading(true));
    yield put(SellerActions.bulkUploadSellersError(null));
    const { payload } = action;
    const bulkUpload = yield SellerService.bulkUploadSellers(payload);
    if (bulkUpload.success) {
      yield put(SellerActions.bulkUploadSellersSuccess(bulkUpload));
      notification.open({
        type: 'success',
        message: 'We are processing your request. Please check the status on bulk imports section.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      yield put(SellerActions.bulkUploadSellersError(bulkUpload.error));
    }
    yield put(SellerActions.bulkUploadSellersLoading(false));
  } catch (error) {
    yield put(SellerActions.bulkUploadSellersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}
function* bulkUploadSellers() {
  yield takeLatest(sellerActionTypes.BULK_UPLOAD_SELLER.REQUEST, _bulkUploadSellers);
}

function* _bulkUpdateSellers(action) {
  try {
    yield put(SellerActions.bulkUpdateSellersLoading(true));
    yield put(SellerActions.bulkUpdateSellersError(null));
    const { payload } = action;
    const bulkUpdate = yield SellerService.bulkUpdateSellers(payload);
    if (bulkUpdate.success) {
      yield put(SellerActions.bulkUpdateSellersSuccess(bulkUpdate));
      notification.open({
        type: 'success',
        message: 'We are processing your request. Please check the status on bulk imports section.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      yield put(SellerActions.bulkUpdateSellersError(bulkUpdate.error));
      notification.open({
        type: 'error',
        message: bulkUpdate.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(SellerActions.bulkUpdateSellersLoading(false));
  } catch (error) {
    yield put(SellerActions.bulkUpdateSellersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* bulkUpdateSellers() {
  yield takeLatest(sellerActionTypes.BULK_UPDATE_SELLER.REQUEST, _bulkUpdateSellers);
}

function* _getTallySellers(action) {
  try {
    yield put(SellerActions.getTallySellersSuccess(null));
    yield put(SellerActions.getTallySellersLoading(true));
    const {
      itId, orgId, searchKeyword, callback, selectedSeller
    } = action;
    const tallySellers = yield SellerService.getTallySellers(itId, orgId, searchKeyword, selectedSeller);
    if (callback) {
      action.callback();
    }
    yield put(SellerActions.getTallySellersSuccess(tallySellers));
    yield put(SellerActions.getTallySellersLoading(false));
  } catch (error) {
    yield put(SellerActions.getTallySellersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(sellerActionTypes.GET_TALLY_SELLERS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getTallySellers() {
  yield takeLatest(sellerActionTypes.GET_TALLY_SELLERS.REQUEST, _getTallySellers);
}

/**
 *
 */
export default function* sellerSaga() {
  yield all([createSeller(), getSellerById(), getSellers(), getStateCity(), deleteSeller(),
  updateSeller(), getSellerOffersById(), updateSellerOffers(), getOrgSellers(), getReports(),
  getDownloadReports(), sendAccountStatementMail(), linkCustomer(), searchSellersName(), getBulkUploadSellerMetadata(), bulkUploadSellers(), bulkUpdateSellers(),
  getTallySellers()]);
}
